/**
 * Trades Table Columns Constants
 * Column width configurations for mobile and desktop views
 */

export const DATE_FORMAT = 'DD.MM.YY HH:mm' as const;

export const CELL_ALIGN = 'left' as const;

export enum TAG_COLORS {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'yellow',
  INFO = 'blue',
}

export const COLUMN_WIDTHS = {
  mobile: {
    id: 60,
    symbol: 90,
    side: 70,
    openDate: 120,
    closeDate: 120,
    entry: 80,
    exit: 70,
    quantity: 80,
    fee: 70,
    swap: 80,
    profitAndLoss: 80,
    status: 90,
    tradeScore: 80,
  },
  desktop: {
    id: 45,
    symbol: 65,
    side: 60,
    openDate: 100,
    closeDate: 100,
    entry: 45,
    exit: 45,
    quantity: 45,
    fee: 55,
    swap: 55,
    profitAndLoss: 50,
    status: 70,
    tradeScore: 80,
  },
} as const;
